var React = require('react');

function CrossInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"cross"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"cross","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","key":2},[React.createElement("line",{"x1":"4","y1":"4","x2":"56","y2":"56","id":"Path-41","stroke":"#000000","strokeWidth":"7","key":0}),React.createElement("line",{"x1":"56","y1":"4","x2":"4","y2":"56","id":"Path-41","stroke":"#000000","strokeWidth":"7","key":1})])]);
}

CrossInline.defaultProps = {"width":"60px","height":"60px","viewBox":"0 0 60 60","version":"1.1"};

module.exports = CrossInline;

CrossInline.default = CrossInline;
